<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos de la operación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Fecha operación</span>
          </div>
          <div>
            <flat-pickr :config="configdateTimePicker" v-model="operacion.fecha" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Tipo de cliente</span>
          </div>
          <div>
            <select-tipo-cliente v-model="operacion.tipoCliente" :tipoClienteSelected="operacion.tipoCliente" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Operador</span>
          </div>
          <div>
            <select-operador v-model="operacion.operador" :operadorSelected="operacion.operador" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Estado</span>
          </div>
          <div>
            <select-val-estado v-model="operacion.valEstado" categoria="OPERACION" :estadoSelected="operacion.valEstado.estado" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>DNI/CIF</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.dni" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Fecha nacimiento</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" :config="configdateTimePicker" v-model="cliente.persona.fechaNacimiento" disabled />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Nombre o razón social</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.nombre" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.apellidos" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Móvil de contacto</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.telefono" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>E-mail</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.email" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos bancarios" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          ¿El titular de la cuenta bancaria es el cliente?
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="S" disabled>Sí</vs-radio>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="N" disabled>No</vs-radio>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Cuenta bancaria</span>
          </div>
          <div>
            <!-- https://es.iban.com/estructura -->
            <vs-input class="w-full" v-model="operacion.iban" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.titularIgualCliente === 'N'">
          <div>
            <span>DNI/CIF</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="titular.persona.dni" disabled/>
          </div>
        </div>
      </div>
        <div class="vx-row mb-2" v-if="operacion.titularIgualCliente === 'N'">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Nombre o razón social</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="titular.persona.nombre" disabled/>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Apellidos</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="titular.persona.apellidos" disabled/>
            </div>
          </div>
        </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Notas" title-color="dark" collapseAction>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea class="w-full" name="observaciones" v-model="operacion.observaciones" height="120px" disabled/>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Usuario creador de la operación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/4 w-full">
          <div>
            <span>Usuario</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="operacion.usuario.username" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full" >
          <div>
            <span>DNI</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="operacion.usuario.dni" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Nombre y apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="usuarioNombreCompleto" disabled />
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Volver</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

import selectValEstado from '@/views/common-components/selectValEstado'
import selectOperador from '@/views/common-components/selectOperador'
import selectTipoCliente from '@/views/common-components/selectTipoCliente'
import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesEditOperacion',
  components: {
    selectValEstado,
    selectOperador,
    selectTipoCliente,
    selectValMunicipio,
    selectValProvincia,
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      operacion: {},
      cliente: {},
      decisor: {},
      titular: {},
      operacionPersona: {},
      titularId: null,

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      }
    }
  },
  computed: {
    usuarioNombreCompleto () {
      return `${this.operacion.usuario.nombre} ${this.operacion.usuario.apellidos}`
    }
  },
  methods: {
    reset_data () {
      this.$router.push({name: 'operaciones'})
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))
    if (this.operacion.tipoCliente === 'EMPRESA') this.decisor = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR')))
    this.titular = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'TITULAR')))
  }
}
</script>

